import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Tag, Button, Typography, Space, Card, Spin, Input, Empty } from "antd";
import { EyeOutlined, ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import axios from "./axiosConfig";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";




const ListadoSCL90 = () => {

  const { Text } = Typography;


  const etapa = "Auxiliar Forense 2026"
  const niSigedi = ObtieneDatosCookies().identificacion
  const permitidoDetalle = localStorage.getItem("permitidoDetalle");

  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("TODOS");

  const navigate = useNavigate()


  //console.log("permitidoDetalle", permitidoDetalle);
  //console.log("etapa", etapa);
  //console.log("niSigedi", niSigedi);


  useEffect(() => {



    traerResultados();

  }, []);


  const detalleExamen = (dni, nombres, apellido, tiene_observacion, observacion) => {
    navigate("/scl-90-resultados", { state: { dni, nombres, apellido, etapa, niSigedi, tiene_observacion, observacion } });
  }



  const vuelveAnterior = () => {
    //navigate("/scl-90-listados");
    window.close();
    //localStorage.clear();
  };


  const traerResultados = async () => {

    try {

      const response = await axios.post(
        "https://wwwp.isepsantafe.net.ar/psicologia/scl90_resultados_general",
        {
          etapa,
        }
      );

      setResultados(response.data.datos || []);

      //console.log("Datos generales", response.data.datos);

      //console.log(response.data.datos[0].nombres);
      //console.log(response.data.datos[0].observacion);


    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);

    }
  };

  const obtenerColor = (resultados) => {

    const tieneLimite = resultados.some(
      (r) =>
        r.supera_limite === "SI" &&
        r.clave !== "ITEMS"
    );

    const tieneIntermedio = resultados.some(
      (r) =>
        r.supera_intermedio === "SI" &&
        r.clave !== "ITEMS"
    );

    if (tieneLimite) return "#ff4d4f";

    if (tieneIntermedio) return "#faad14";

    return "#52c41a";
  };



  const resultadosFiltrados = resultados.filter((persona) => {

    const texto = busqueda.toLowerCase();

    const coincideBusqueda =
      persona.apellido?.toLowerCase().includes(texto) ||
      persona.nombres?.toLowerCase().includes(texto) ||
      persona.dni?.toString().includes(texto);

    // SOLO ESCALAS REALES
    const escalas = persona.resultados.filter(
      (r) =>
        (r) => r.clave !== "ITEMS"
    );

    // TIENE ROJOS
    const tieneCritico = escalas.some(
      (r) => r.supera_limite === "SI"
    );

    // TIENE AMARILLOS
    const tieneAtencion = escalas.some(
      (r) =>
        r.supera_intermedio === "SI" &&
        r.supera_limite !== "SI"
    );

    // FILTRO
    let coincideFiltro = true;

    if (filtroEstado === "CRITICO") {
      coincideFiltro = tieneCritico;
    }

    if (filtroEstado === "ATENCION") {
      coincideFiltro =
        !tieneCritico && tieneAtencion;
    }

    if (filtroEstado === "NORMAL") {
      coincideFiltro =
        !tieneCritico &&
        !tieneAtencion;
    }

    return coincideBusqueda && coincideFiltro;
  });


// -------- Desarcarga excel ---------

const descargarExcel = async () => {

  try {

    const response = await axios.post(
      "https://wwwp.isepsantafe.net.ar/psicologia/excel_scl90",
      {
        etapa
      },
      {
        responseType: "blob"
      }
    );

    // Crear blob
    const blob = new Blob(
      [response.data],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    );

    // Crear URL temporal
    const url =
      window.URL.createObjectURL(blob);

    // Crear link
    const link =
      document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `scl90_${etapa}.xlsx`
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (error) {

    console.error(error);

    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        "No se pudo descargar el Excel"
    });

  }

};








  if (loading) {

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: 40,
        }}
      >
        <Spin />
      </div>
    );
  }

  return (

    <div
      style={{
        padding: 18,
        background: "#f5f7fa",
        minHeight: "100vh",
      }}
    >

      {/* HEADER PRINCIPAL */}

      <Card
        size="small"
        variant="borderless"
        style={{
          marginBottom: 16,
        }}
      >

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 10,
          }}
        >

          <div>

            <div
              style={{
                fontSize: 34,
                fontWeight: 700,
                lineHeight: 1,
                letterSpacing: "-1px",
              }}
            >
              SCL-90-R
            </div>

            <Text type="secondary">
              Evaluaciones psicológicas
            </Text>
            <Tag
              color="blue"
              style={{
                fontSize: 14,
                padding: "4px 10px",
                marginLeft: "15px",
              }}
            >
              Total: {resultadosFiltrados.length}
            </Tag>

          </div>



          <Button
            type="primary"
            style={{ backgroundColor: "#389e0d", borderColor: "#389e0d" }}
            onClick={descargarExcel}
          >
            Descargar Excel
          </Button>

          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={vuelveAnterior}
          >
            Volver
          </Button>

        </div>



      </Card>

      {/* Inicio Buscador */}
      {/* Inicio Buscador */}
      <Card
        size="small"
        variant="borderless"
        style={{
          marginBottom: 16,
        }}
      >

        {/* FILTROS */}

        <div
          style={{
            display: "flex",
            gap: 8,
            marginBottom: 12,
            flexWrap: "wrap",
          }}
        >

          <Button
            type={filtroEstado === "TODOS" ? "primary" : "default"}
            onClick={() => setFiltroEstado("TODOS")}
          >
            Todos
          </Button>

          <Button
            danger
            type={filtroEstado === "CRITICO" ? "primary" : "default"}
            onClick={() => setFiltroEstado("CRITICO")}
          >
            Crítico
          </Button>

          <Button
            type={filtroEstado === "ATENCION" ? "primary" : "default"}
            onClick={() => setFiltroEstado("ATENCION")}
            style={
              filtroEstado === "ATENCION"
                ? {
                  background: "#faad14",
                  borderColor: "#faad14",
                }
                : {}
            }
          >
            Atención
          </Button>

          <Button
            type={filtroEstado === "NORMAL" ? "primary" : "default"}
            onClick={() => setFiltroEstado("NORMAL")}
            style={
              filtroEstado === "NORMAL"
                ? {
                  background: "#52c41a",
                  borderColor: "#52c41a",
                }
                : {}
            }
          >
            S/Obs
          </Button>

        </div>

        {/* BUSCADOR */}

        <Input
          placeholder="Buscar por apellido o DNI"
          prefix={<SearchOutlined />}
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          allowClear
        />

      </Card>

      {/* Fin Buscador */}

      {/* LISTADO */}

      <Card
        size="small"
        variant="borderless"
      >

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >


          {
            resultadosFiltrados.length === 0 ? (

              <Empty
                description="No se encontraron personas"
              />

            ) : (


              resultadosFiltrados.map((persona, index) => {

                //console.log(persona);

                const alterados = persona.resultados.filter(
                  (r) =>
                    (
                      r.supera_limite === "SI" ||
                      r.supera_intermedio === "SI"
                    ) &&
                    r.clave !== "ITEMS"
                );

                const igs = persona.resultados.find(
                  (r) => r.clave === "IGS"
                );

                const tsp = persona.resultados.find(
                  (r) => r.clave === "TSP"
                );

                const imsp = persona.resultados.find(
                  (r) => r.clave === "IMSP"
                );

                return (

                  <Card
                    key={persona.dni || index}
                    size="small"
                    style={{
                      border: "1px solid #f0f0f0",
                    }}
                  >

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 20,
                        flexWrap: "wrap",
                      }}
                    >

                      {/* IZQUIERDA */}

                      <div
                        style={{
                          display: "flex",
                          gap: 14,
                          flex: 1,
                          minWidth: 260,
                        }}
                      >

                        <Avatar
                          size={42}
                          style={{
                            background: obtenerColor(
                              persona.resultados
                            ),
                            fontWeight: "bold",
                            flexShrink: 0,
                          }}
                        >
                          {alterados.length}
                        </Avatar>

                        <div>

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 10,
                              alignItems: "center",
                              marginBottom: 4,
                            }}
                          >

                            <Text
                              strong
                              style={{
                                fontSize: 14,
                              }}
                            >
                              {persona.nombres + " " + persona.apellido || "Sin nombre"}
                            </Text>

                            <Text type="secondary">
                              DNI: {persona.dni}
                            </Text>

                          </div>

                          <div
                            style={{
                              marginBottom: 8,
                            }}
                          >
                            <Text type="secondary">
                              {persona.etapa}
                            </Text>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 4,
                            }}
                          >

                            {
                              alterados.length === 0 ? (

                                <Tag color="success">
                                  S/Obs
                                </Tag>

                              ) : (

                                alterados.map((item, idx) => {

                                  let colorTag = "success";

                                  if (item.supera_limite === "SI") {

                                    colorTag = "error";

                                  } else if (item.supera_intermedio === "SI") {

                                    colorTag = "warning";
                                  }

                                  return (

                                    <Tag
                                      key={idx}
                                      color={colorTag}
                                    >
                                      {item.clave} {item.valor_t}
                                    </Tag>

                                  );

                                })
                              )
                            }

                          </div>

                        </div>

                      </div>

                      {/* DERECHA */}

                      <div
                        style={{

                        }}
                      >

                        <Space size={18}>

                          <div>
                            <Text type="secondary">
                              IGS
                            </Text>

                            <div
                              style={{
                                fontWeight: 700,
                                textAlign: "center",
                              }}
                            >
                              {igs?.valor_t || "-"}
                            </div>
                          </div>

                          <div>
                            <Text type="secondary">
                              TSP
                            </Text>

                            <div
                              style={{
                                fontWeight: 700,
                                textAlign: "center",
                              }}
                            >
                              {tsp?.valor_t || "-"}
                            </div>
                          </div>

                          <div>
                            <Text type="secondary">
                              IMSP
                            </Text>

                            <div
                              style={{
                                fontWeight: 700,
                                textAlign: "center",
                              }}
                            >
                              {imsp?.valor_t || "-"}
                            </div>
                          </div>

                        </Space>

                        <div>

                          <Button
                            size="small"
                            type="primary"
                            icon={<EyeOutlined />}
                            onClick={() => detalleExamen(persona.dni, persona.nombres, persona.apellido, persona.observacion, persona.tiene_observacion)}
                          >
                            Ver
                          </Button>

                          {persona.tiene_observacion && (
                            <Tag color="warning">
                              Tiene Observación
                            </Tag>
                          )}

                        </div>

                      </div>


                      {/*---------------------------------------------------------------------------------------------------------------------*/}




                    </div>

                  </Card>

                );

              })

            )
          }

        </div>

      </Card>

    </div>
  );
};

export default ListadoSCL90;